import React, { useState } from "react";
import { toast } from "sonner";
import { MessageCircle, Ticket, Send } from "lucide-react";
import { TICKETS, CHAT, PUBLISHER } from "../demoData";
import { Card, CardHead, PageTitle, Badge, Btn, inputCls } from "../ui";

const Chat = () => {
  const [msgs, setMsgs] = useState(CHAT);
  const [text, setText] = useState("");
  const send = (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    setMsgs((m) => [...m, { from: "me", text, time: "Now" }]);
    setText("");
    setTimeout(() => setMsgs((m) => [...m, { from: "manager", text: "Thanks! I'll get back to you shortly.", time: "Now" }]), 900);
  };
  return (
    <Card className="lg:col-span-3 flex flex-col" testId="support-chat">
      <CardHead icon={MessageCircle} title={`Chat with ${PUBLISHER.manager} · Account Manager`} right={<span className="flex items-center gap-1.5 text-xs text-emerald-400"><span className="w-2 h-2 rounded-full bg-emerald-400" />Online</span>} />
      <div className="flex-1 p-5 space-y-3 min-h-[280px] max-h-[380px] overflow-y-auto">
        {msgs.map((m, i) => (
          <div key={i} className={`flex ${m.from === "me" ? "justify-end" : "justify-start"}`}>
            <div className={`max-w-[80%] rounded-2xl px-4 py-2.5 text-sm ${m.from === "me" ? "bg-blue-600 text-white rounded-br-sm" : "bg-[#161d28] text-slate-200 rounded-bl-sm"}`}>
              {m.text}<p className="mt-1 text-[10px] opacity-60">{m.time}</p>
            </div>
          </div>
        ))}
      </div>
      <form onSubmit={send} className="flex gap-2 p-4 border-t border-slate-800">
        <input className={inputCls} placeholder="Type a message…" value={text} onChange={(e) => setText(e.target.value)} data-testid="support-chat-input" />
        <Btn type="submit" data-testid="support-chat-send"><Send className="w-4 h-4" /></Btn>
      </form>
    </Card>
  );
};

const Tickets = () => {
  const [list, setList] = useState(TICKETS);
  const [subject, setSubject] = useState("");
  const create = (e) => {
    e.preventDefault();
    if (!subject.trim()) return;
    setList((l) => [{ id: `TCK-${3100 + l.length}`, subject, status: "Open", updated: "Just now" }, ...l]);
    setSubject("");
    toast.success("Ticket created");
  };
  return (
    <Card className="lg:col-span-2" testId="support-tickets">
      <CardHead icon={Ticket} title="Support Tickets" />
      <form onSubmit={create} className="flex gap-2 p-4 border-b border-slate-800">
        <input className={inputCls} placeholder="New ticket subject" value={subject} onChange={(e) => setSubject(e.target.value)} data-testid="support-ticket-input" />
        <Btn type="submit" data-testid="support-ticket-create">Create</Btn>
      </form>
      <div className="divide-y divide-slate-800">
        {list.map((t) => (
          <div key={t.id} className="px-5 py-3.5" data-testid={`ticket-${t.id}`}>
            <div className="flex items-center justify-between gap-2">
              <span className="text-xs font-mono text-slate-500">{t.id}</span>
              <Badge>{t.status}</Badge>
            </div>
            <p className="mt-1 text-sm text-slate-200">{t.subject}</p>
            <p className="text-[11px] text-slate-500">Updated {t.updated}</p>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default function Support() {
  return (
    <>
      <PageTitle title="Support" sub="Your dedicated account manager typically replies within a few hours." />
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-4">
        <Chat />
        <Tickets />
      </div>
    </>
  );
}
